<template>
  <div v-title="$route.meta.title"
       class="inbox-page">
    <div class="inbox-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>工作管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息通知</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="inbox-content">
      <header class="page-intro">
        <h2>消息通知</h2>
        <p>审单反馈、出勤与问卷提醒，点击「查看详情」跳转处理或标记为已读</p>
      </header>

      <section class="inbox-card"
               v-loading="loading">
        <nav class="message-filters"
             aria-label="消息分类">
          <button v-for="filter in filters"
                  :key="filter.key"
                  type="button"
                  class="filter-button"
                  :class="{'is-active': activeFilter === filter.key}"
                  :data-filter="filter.key"
                  @click="changeFilter(filter.key)">
            <span>{{ filter.label }}</span>
            <span class="filter-count"
                  :class="`filter-count--${filter.tone}`">
            {{ counts[filter.countKey] || 0 }}
          </span>
          </button>
        </nav>

        <div v-if="errorMessage && !loading"
             class="message-state">
          <i class="el-icon-warning-outline"></i>
          <p>{{ errorMessage }}</p>
          <el-button type="primary"
                     plain
                     size="small"
                     @click="loadMessages">重新加载
          </el-button>
        </div>

        <div v-else-if="!messages.length && !loading"
             class="message-state">
          <i class="el-icon-message"></i>
          <p>暂无消息通知</p>
        </div>

        <div v-else
             class="message-list">
          <article v-for="message in messages"
                   :key="message.id"
                   class="message-item"
                   :class="{'is-unread': Number(message.is_read) === 0}">
            <div class="message-icon"
                 :class="`message-icon--${getCategoryMeta(message.category).tone}`">
              <i :class="getCategoryMeta(message.category).icon"></i>
            </div>

            <div class="message-main">
              <div class="message-title-row">
                <span v-if="Number(message.is_read) === 0"
                      class="unread-dot"
                      title="未读"></span>
                <h3 style="  font-size: 14px;">{{ message.title }}</h3>
              </div>
              <p class="message-content">{{ message.content || '暂无消息内容' }}</p>
              <time class="message-time">{{ message.created_at || '-' }}</time>
            </div>

            <div class="message-actions">
            <span class="category-tag"
                  :class="`category-tag--${getCategoryMeta(message.category).tone}`">
              {{ getCategoryMeta(message.category).label }}
            </span>
              <el-button class="message-detail-button"
                         icon="el-icon-view"
                         size="small"
                         @click="handleReadMessage(message)">
                查看详情
              </el-button>
            </div>
          </article>
        </div>

        <div v-if="total > 0"
             class="message-pagination">
          <el-pagination background
                         :current-page="currentPage"
                         :page-size="pageSize"
                         :page-sizes="[20, 50, 100]"
                         :total="total"
                         layout="total, sizes, prev, pager, next, jumper"
                         @size-change="changePageSize"
                         @current-change="changePage">
          </el-pagination>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
const EMPTY_COUNTS = {
  all: 0,
  unread: 0,
  order_review: 0,
  attendance: 0,
  questionnaire: 0,
}

export default {
  name: 'AdminInboxMessageTable',
  data () {
    return {
      loading: false,
      errorMessage: '',
      activeFilter: 'all',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      messages: [],
      counts: {...EMPTY_COUNTS},
      filters: [
        {key: 'all', label: '全部', countKey: 'all', tone: 'default'},
        {key: 'unread', label: '未读', countKey: 'unread', tone: 'danger'},
        {key: 'order_review', label: '审单相关', countKey: 'order_review', tone: 'primary'},
        {key: 'attendance', label: '出勤相关', countKey: 'attendance', tone: 'success'},
        {key: 'examination', label: '问卷相关', countKey: 'examination', tone: 'purple'},
      ],
      categoryMap: {
        1: {label: '审单相关', tone: 'primary', icon: 'el-icon-s-order'},
        2: {label: '出勤相关', tone: 'success', icon: 'el-icon-date'},
        3: {label: '问卷相关', tone: 'purple', icon: 'el-icon-document'},
      },
    }
  },
  created () {
    this.loadMessages()
  },
  methods: {
    handleReadMessage: function (message) {
      request.alert('readAdminInboxMessage', {id: message.id}).then(res => {
        let category = message.category * 1
        if (category === 1) {
          this.$router.push({path: `/audit-task/table?order_id=${message.ref_id}`})
        } else if (category === 2) {
          this.$router.push('/workbench/attendance-plan?plan_month=' + message.params.next_month)
        } else if (category === 3) {
          this.$router.push('/training/self-examination')
        }
      })
    },
    getCategoryMeta (category) {
      return this.categoryMap[Number(category)] || {
        label: '其他消息',
        tone: 'default',
        icon: 'el-icon-message',
      }
    },
    normalizePayload (response) {
      const body = response && response.data ? response.data : {}
      return body && body.detail ? body.detail : body
    },
    loadMessages () {
      const params = {
        filter: this.activeFilter,
        current_page: this.currentPage,
        per_page: this.pageSize,
      }
      this.loading = true
      this.errorMessage = ''
      request.alert('queryAdminInboxMessage', params).then(response => {
        const data = this.normalizePayload(response) || {}
        this.messages = Array.isArray(data.data) ? data.data : []
        this.total = Number(data.total) || 0
        this.currentPage = Number(data.current_page) || this.currentPage
        this.pageSize = Number(data.per_page) || this.pageSize
        this.counts = {...EMPTY_COUNTS, ...(data.counts || {})}
      }).catch(() => {
        this.messages = []
        this.total = 0
        this.errorMessage = '消息通知加载失败，请稍后重试'
      }).then(() => {
        this.loading = false
      })
    },
    changeFilter (filter) {
      if (filter === this.activeFilter) return
      this.activeFilter = filter
      this.currentPage = 1
      this.loadMessages()
    },
    changePage (page) {
      this.currentPage = page
      this.loadMessages()
    },
    changePageSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadMessages()
    },
  },
}
</script>

<style scoped
       lang="scss">
$primary: #3d7eff;
$success: #25bd69;
$purple: #8b53e6;
$danger: #f45b5b;
$muted: #8a94a6;
$border: #edf0f5;

.inbox-page {
  min-height: 100%;
  box-sizing: border-box;
  background: #f4f6f9;
}

.inbox-breadcrumb {
  padding: 24px 32px;
  background: #fff;
  border-bottom: 1px solid $border;
}

.inbox-content {
  padding: 28px 24px 40px;
}

.page-intro {
  max-width: 900px;
  margin: 0 auto 28px;

  h2 {
    margin: 0 0 8px;
    color: #202938;
    font-size: 20px;
    line-height: 1.35;
  }

  p {
    margin: 0;
    color: #7b8495;
    font-size: 14px;
    line-height: 1.6;
  }
}

.inbox-card {
  max-width: 900px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid $border;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(34, 48, 74, 0.05);
}

.message-filters {
  display: flex;
  align-items: stretch;
  min-height: 76px;
  padding: 0 32px;
  border-bottom: 1px solid $border;
  gap: 40px;
}

.filter-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  outline: 0;
  color: #6b7484;
  background: transparent;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  gap: 10px;

  &::after {
    position: absolute;
    right: 0;
    bottom: -1px;
    left: 0;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: $primary;
    content: '';
    opacity: 0;
    transform: scaleX(0.5);
    transition: opacity 0.2s, transform 0.2s;
  }

  &.is-active {
    color: $primary;

    &::after {
      opacity: 1;
      transform: scaleX(1);
    }
  }
}

.filter-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 15px;
  color: #697386;
  background: #f1f3f6;
  font-size: 14px;

  &--danger {
    color: $danger;
    background: #fff0f0;
  }

  &--primary {
    color: $primary;
    background: #edf4ff;
  }

  &--success {
    color: $success;
    background: #ebf9f1;
  }

  &--purple {
    color: $purple;
    background: #f6efff;
  }
}

.message-list {
  min-height: 170px;
}

.message-item {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 125px;
  padding: 24px 32px;
  box-sizing: border-box;
  border-bottom: 1px solid $border;
  gap: 26px;

  &:last-child {
    border-bottom: 0;
  }

  &.is-unread {
    background: linear-gradient(90deg, rgba(61, 126, 255, 0.025), transparent 38%);
  }
}

.message-icon {
  display: flex;
  flex: 0 0 64px;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 13px;
  color: #748196;
  background: #f2f4f7;
  font-size: 27px;

  &--primary {
    color: $primary;
    background: #eaf2ff;
  }

  &--success {
    color: $success;
    background: #eaf8f0;
  }

  &--purple {
    color: $purple;
    background: #f5edff;
  }
}

.message-main {
  flex: 1 1 auto;
  min-width: 0;
}

.message-title-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 9px;

  h3 {
    overflow: hidden;
    margin: 0;
    color: #5d687a;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.unread-dot {
  flex: 0 0 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: $primary;
}

.message-content,
.message-time {
  display: block;
  margin: 5px 0 0;
  color: $muted;
  font-size: 12px;
  line-height: 1.55;
}

.message-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-time {
  color: #a8b0bf;
}

.message-actions {
  display: flex;
  flex: 0 0 220px;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
}

.category-tag {
  padding: 7px 12px;
  border-radius: 8px;
  color: #748196;
  background: #f2f4f7;
  font-size: 13px;
  white-space: nowrap;

  &--primary {
    color: $primary;
    background: #edf4ff;
  }

  &--success {
    color: $success;
    background: #eaf8f0;
  }

  &--purple {
    color: $purple;
    background: #f6efff;
  }
}

.message-detail-button {
  min-width: 108px;
}

.message-state {
  display: flex;
  min-height: 280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #a1a9b7;
  gap: 12px;

  i {
    font-size: 40px;
  }

  p {
    margin: 0;
    font-size: 15px;
  }
}

.message-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 22px 32px;
  border-top: 1px solid $border;
}

@media (max-width: 900px) {
  .inbox-page {
    padding: 0;
  }

  .inbox-breadcrumb {
    padding: 20px;
  }

  .inbox-content {
    padding: 20px 12px 32px;
  }

  .message-filters {
    overflow-x: auto;
    padding: 0 20px;
    gap: 28px;
  }

  .filter-button {
    flex: 0 0 auto;
  }

  .message-item {
    align-items: flex-start;
    padding: 22px 20px;
    gap: 16px;
  }

  .message-actions {
    flex: 0 0 auto;
    align-items: flex-end;
    flex-direction: column;
    gap: 12px;
  }
}

@media (max-width: 640px) {
  .page-intro h2 {
    font-size: 24px;
  }

  .message-item {
    flex-wrap: wrap;
  }

  .message-icon {
    flex-basis: 52px;
    width: 52px;
    height: 52px;
  }

  .message-main {
    width: calc(100% - 68px);
  }

  .message-actions {
    width: 100%;
    flex-basis: 100%;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
  }

  .message-pagination {
    overflow-x: auto;
    justify-content: flex-start;
    padding: 18px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin-inbox-message/pages/AdminInboxMessageTable.vue